import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  templateForm: {
    height: 'auto',
    width: '100%',
    maxWidth: theme.spacing(68.12),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1.25),
  },
  formStyle: { display: 'flex', width: '100%' },
  footerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  footerWrapperButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  templateContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
    margin: theme.spacing(-4),
  },
  formContainer: {
    width: '100%',
  },
  footerActions: {
    width: theme.spacing(115),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(0.5),
  },
  description: {
    color: theme.palette.labraText.secondary,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  autosave: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(5),
    fontSize: '14px',
    color: theme.palette.text.secondary,
    '&.loading': {
      color: theme.palette.info.main,
    },
    '&.success': {
      color: theme.palette.success.main,
    },
    '&.error': {
      color: theme.palette.error.main,
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(12.5),
  },
  horizontalDivider: {
    height: '1px',
    backgroundColor: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(-4),
    marginRight: theme.spacing(-4),
  },
  cardHeadingWrapper: {
    gap: theme.spacing(2),
  },
}))
